import React from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
//import Home from './Home/';
import Login from './Login/';
import Password from './Password/';
import Signup from './Signup/'; 
import Acerca from './Acerca';


function Public(props) {
  return (
    <main>
      <BrowserRouter>
        
        <Route path="/" exact render={()=><Login setAuthentication={props.setAuthentication} />} />
        <Route path="/signup" component={Signup} render={()=><Signup setAuthentication={props.setAuthentication} />} />
        <Route path="/password" component={Password} />
        <Route path="/acerca" component={Acerca} />
      </BrowserRouter>
    </main>
  );
}

export default Public;
